<template>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition"
              v-model="dialog">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-btn @click.native="dialog = false" dark icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ resource.title }}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn color="primary" depressed large @click.native="dialog = false">Završi uređivanje</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-container grid-list-sm>
                <v-layout row wrap>
                    <v-col cols="12">
                        <v-text-field
                                v-model="phrase"
                                @input="performSearch"
                                outline
                                hide-details
                                prepend-inner-icon="mdi-magnify"
                                label="Pretraga"
                                style="margin-bottom: 20px;">
                        </v-text-field>

                        <v-data-table
                                :items="items"
                                :headers="[{text:'Posjeduje', value:'', sortable:false}, {text:'Oznaka', value:'title'}, {text:'Naziv', value:'value'}]"
                                :options.sync="options"
                                item-key="name"
                                class="elevation-1 fixed-header">
                            <template v-slot:body="{ items }">
                                <tbody>
                                <tr :key="item.name" v-for="item in items">
                                    <td>
                                        <v-checkbox
                                                v-model="item.own"
                                                @change="changedPermission(item)"
                                                primary
                                                hide-details
                                                style="margin: auto;">
                                        </v-checkbox>
                                    </td>
                                    <td>{{ item.title }}</td>
                                    <td>{{ item.name }}</td>
                                </tr>
                                </tbody>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

    import {serverBus} from "../../main";

    export default {

        created: function () {
            serverBus.$on('edit-role-permissions', (resource) => {
                this.resource = resource;
                this.dialog = true;

                this.getData()
            });

            serverBus.$on('close-edit-role-dialog', () => {
                this.dialog = false;
            })
        },

        methods: {
            getData() {
                this.$axios.post('ostalo/uloga/dozvole', {role_id: this.resource.id}).then(response => {
                    let has_permissions = response.data.has_permissions;
                    let has_not_permissions = response.data.has_not_permissions;

                    for (let i = 0; i < has_permissions.length; i++) {
                        let item = has_permissions[i];

                        item.own = true;
                    }

                    for (let i = 0; i < has_not_permissions.length; i++) {
                        let item = has_not_permissions[i];

                        item.own = false;
                    }

                    let all_permissions = has_permissions.concat(has_not_permissions);

                    this.items = all_permissions;
                    this.itemsOriginal = all_permissions;
                });
            },

            performSearch: function () {
                let items = [];

                for (let i = 0; i < this.itemsOriginal.length; i++) {
                    if (this.itemsOriginal[i].title.toLowerCase().includes(this.phrase.toLowerCase())) {
                        items.push(this.itemsOriginal[i])
                    }
                }

                this.items = items;
                this.options.page = 1;
            },

            changedPermission: function (item) {
                let form = {role_id: this.resource.id, permission_id: item.id};

                this.$axios.post('/ostalo/uloga/dozvola/' + (item.own ? 'dodaj' : 'izbrisi'), form).then(() => {
                    serverBus.$emit('show-snackbar', true);
                }).catch(function () {
                    serverBus.$emit('show-snackbar', false);
                });
            }
        },

        watch: {
            dialog: {
                handler() {
                    if (this.dialog === false) {
                        this.phrase = '';
                    }
                }
            }
        },

        beforeDestroy() {
            serverBus.$off('edit-role-permissions');
            serverBus.$off('close-edit-role-dialog');
        },

        data: function () {
            return {
                phrase: '',
                dialog: false,
                request: null,
                resource: {},
                items: [],
                itemsOriginal: [],
                options: {
                    itemsPerPage: 10,
                },
            }
        },
    }
</script>